module.exports = __webpack_public_path__ + "img/Ikon_CO2_Modul.fad43b92.svg";